<template>
    <div id="schoolSignupNoticeList">
        <div class="second-header-wrap">
            <el-select size="medium" v-model="currentNotice" @change="searchHandler" placeholder="请选择">
                <el-option
                    v-for="noticeItem in noticeList"
                    :key="noticeItem.id"
                    :label="noticeItem.title"
                    :value="noticeItem.id">
                </el-option>
            </el-select>
            <el-input size="medium" style="width: 230px;" v-model.trim="searchVal"  placeholder="身份证/护照/学生姓名/招生序号/报名编号" @keyup.enter.native="searchHandler"></el-input>
            <el-button type="primary" @click="searchHandler" size="medium">搜索</el-button>
            <el-button type="primary" @click="batchSignup" size="medium" v-if="checkIndexPermission(permission, '/staterunEnrolSystem/enrolStuAdmitAndRemark')">录取</el-button>
            <a :href="exportURL" download="导出" target="_blank">
                <el-button class="filter-item" type="primary" icon="upload" size="medium">导出</el-button>
            </a>
            <a :href="exportAllURL" download="导出" target="_blank">
                <el-button class="filter-item" type="primary" icon="upload" size="medium">导出详细数据</el-button>
            </a>
        </div>
        <div class="table-container">
            <el-table
                ref="messageTable"
                :data="dataList"
                class="messageTable custom—scrollbar"
                fit
                style="width: 100%"
                border
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    type="selection" align="center"
                    width="55"
                    v-if="checkIndexPermission(permission, '/staterunEnrolSystem/enrolStuAdmitAndRemark')"
                >
                </el-table-column>
                <el-table-column
                    label="报名序号" align="center" prop="orderNo">
                </el-table-column>
                <el-table-column
                    v-if="hasApplyNo"
                    label="报名编号" align="center" show-overflow-tooltip width="120">
                    <template slot-scope="scope">
                        {{scope.row.applyNo}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="姓名" align="center" show-overflow-tooltip width="300">
                    <template slot-scope="scope">
                        <router-link :to="{path: 'reviewQuestionnaireDetail', query: {stuId: scope.row.id, fromReserve: 1, orderNo: scope.row.orderNo, noticeId: scope.row.noticeId}}">{{scope.row.stuName}}</router-link>
                    </template>
                </el-table-column>
                <el-table-column
                    label="性别" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.gender === 1 ? '男' : '女'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="身份证/护照号" align="center" prop="idCard">
                </el-table-column>
                <el-table-column
                    label="家长手机号" align="center">
                    <template slot-scope="scope">
                        {{scope.row.loginPhone || scope.row.fatherPhone || scope.row.matherPhone}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="报名时间" align="center">
                    <template slot-scope="scope">
                        {{scope.row.createTime | timeSuffixFilter}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="状态" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.state === 3">已录取</span>
                        <span v-else-if="scope.row.state === 8">预录取</span>
                        <span v-else-if="scope.row.finalState === 1">二审通过</span>
                        <span v-else-if="scope.row.finalState === 2">不同意一审意见</span>
                        <span v-else-if="scope.row.offlineState === -1">一审待定</span>
                        <span v-else-if="scope.row.offlineState === 0">一审未审核</span>
                        <span v-else-if="scope.row.offlineState === 1">一审通过</span>
                        <span v-else-if="scope.row.offlineState === 2">待上报</span>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="checkIndexPermission(permission, '/staterunEnrolSystem/enrolStuAdmitAndRemark')"
                    label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button :disabled="scope.row.state === 3" size="small" type="text" @click.native="signup(scope.row)">
                            录取
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
          <el-dialog title="批量录取返回信息" :close-on-press-escape='false' :close-on-click-modal='false' :visible.sync="mypop" width="700px" :lock-scroll="false" :modal-append-to-body='false'>

        <div class="error-msg-container" >
            <div v-for="(item,index) in mydata" class="li" :key="index">
                {{item}}
                </div> 
         </div>
        <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="mypop = false">确 定</el-button>
                </span>
      </el-dialog>
        <div class="pagination-container">
            <el-pagination
                @size-change="sizeChangeHandler"
                @current-change="currentChangeHandler"
                :current-page.sync="pagination.pageNo"
                :page-sizes="[10 , 20, 30, 50]"
                :page-size.sync="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :page-count="pagination.pages"
                :total="pagination.total"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {
        getNoticeApplyStuPageList,
        getSchoolEnrolFieldList,
        getSchoolEnrolNoticeList,
        admitStu
    } from '@/api/primary/review';
    import baseMixin from '@/mixins/baseMixin';
    import {mapGetters} from 'vuex';

    export default {
        name: "ReviewOffline",
        data() {
            return {
                dataList: [],
                searchVal: '',
                yearNo:'',
                searchList:[],
                fieldNameList:[],
                noticeList: [],
                currentNotice: null,
                firstReviewRule: {
                    offlineOptions: [{
                        required: true, message: '请输入一审意见', trigger: 'blur'
                    }],
                    offlinePendIdslist: [
                        { type: 'array', required: true, message: '请至少选择一个待定原因', trigger: 'change' }
                    ],
                },
                hasApplyNo: true,
                mypop:false,
                mydata:[]
            }
        },
        computed: {
            ...mapGetters(['userInfo', 'permission']),
            exportURL: function () {
                return `${global.BasePath}structure/staterunEnrol/exportStuList?noticeId=${this.currentNotice}&state=8&token=${this.$store.getters.token}`;
            },
            exportAllURL: function() {
                return `${global.BasePath}structure/staterunEnrol/exportApplyStuListBySchool?noticeId=${this.currentNotice}&state=8&token=${this.$store.getters.token}`;
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                if(from.name === 'ReviewQuestionnaireDetail') {
                    const reviewOfflineMetaStr = sessionStorage.getItem('reviewOfflineMeta');
                    if(reviewOfflineMetaStr) {
                        const reviewOfflineMeta = JSON.parse(reviewOfflineMetaStr);
                        vm.currentNotice = reviewOfflineMeta.currentNotice;
                        vm.pagination.pageSize = reviewOfflineMeta.pageSize;
                        vm.pagination.pageNo = reviewOfflineMeta.pageNo;
                        vm.pagination.pages = reviewOfflineMeta.pages;

                        getSchoolEnrolNoticeList({
                            searchVal: '',
                            state: 2,
                            pageSize: reviewOfflineMeta.pageSize,
                            pageNo: reviewOfflineMeta.pageNo
                        })
                            .then(res => res.data)
                            .then(data => {
                                vm.noticeList = data.data;
                            });
                        vm.searchHandler();
                    }
                } else {
                    sessionStorage.setItem('reviewOfflineMeta', '');

                    getSchoolEnrolNoticeList({
                        searchVal: '',
                        state: 2,
                        pageSize: 10,
                        pageNo: 1
                    })
                        .then(res => res.data)
                        .then(data => {
                            vm.noticeList = data.data;
                            if(data.data.length !== 0) {
                                vm.currentNotice = data.data[0].id;
                                vm.searchHandler();
                            }
                        });


                }
            });
        },
        beforeRouteLeave (to, from, next) {
            sessionStorage.setItem('reviewOfflineMeta', JSON.stringify({
                currentNotice: this.currentNotice,
                pageSize: this.pagination.pageSize,
                pageNo: this.pagination.pageNo,
                pages: this.pagination.pages,
            }));
            next();
        },
        created() {
            this.getSchoolEnrolFieldListFunc();
        },
        mixins: [baseMixin],
        methods: {
            currentChangeHandler() {
                this.getNoticeApplyStuPageListFunc();
            },
            sizeChangeHandler() {
                this.getNoticeApplyStuPageListFunc();
            },
            handleSelectionChange(selection) {
                this.selection = selection;
            },
            batchSignup() {
                if(this.selection && this.selection.length !== 0) {
                    this.$confirm('是否录取?', '录取', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        const args = [];
                        this.selection.forEach(stuItem => {
                            if(stuItem.state !== 3) {
                                args.push(stuItem.id);
                            }
                        });
                        if(args.length !== 0) {
                            admitStu({
                                stuIds: args.join(','),
                                noticeId: this.currentNotice
                            })
                                .then(res => res.data)
                                .then(data => {
                                    if(data.result) {
                                        this.$message({
                                            message: '录取成功',
                                            type: 'success'
                                        });
                                        this.getNoticeApplyStuPageListFunc();
                                    } else {                                        
                                        if(data&&data.data.length){
                                           this.mydata=data.data;
                                           this.mypop=true;
                                            this.getNoticeApplyStuPageListFunc();
                                        }else{
                                            this.$message.error(data.msg);
                                        }
                                       
                                    }
                                });
                        }


                    });
                } else{
                    this.$message.error('请选择学生');
                }
            },
            signup(studentInfo) {
                this.$confirm('是否录取?', '录取', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    admitStu({
                        stuIds: studentInfo.id,
                        noticeId: this.currentNotice
                    })
                        .then(res => res.data)
                        .then(data => {
                            if(data.result) {
                                this.$message({
                                    message: '录取成功',
                                    type: 'success'
                                });
                                this.getNoticeApplyStuPageListFunc();
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                }).catch(() => {
                });
            },

            examHandler(id){
                this.listQuery.id=id;
                this.listQuery.finalState=1;
                if(this.fieldNameList.indexOf('isProperty')!==-1){
                    this.listQuery.isProperty=1;
                }
                if(this.fieldNameList.indexOf('isRealLive')!==-1){
                    this.listQuery.isRealLive=1;
                }
                if(this.fieldNameList.indexOf('isTeachArea')!==-1){
                    this.listQuery.isTeachArea=1;
                }
                if(this.fieldNameList.indexOf('isTeachAreaNotice')!==-1){
                    this.listQuery.isTeachAreaNotice=1;
                }
                if(this.fieldNameList.indexOf('isVisit')!==-1){
                    this.listQuery.isVisit=1;
                }
                this.examVisible=true;
            },
            getSchoolEnrolFieldListFunc(){
                getSchoolEnrolFieldList({
                    yearNo:this.$moment(new Date()).format('YYYY')
                })
                    .then(res=>res.data)
                    .then(data=>{
                        if(data.code===200){

                            this.searchList=data.data;
                            this.fieldNameList=[];
                            this.searchList.forEach((item,index)=>{
                                this.fieldNameList.push(item.fieldName);
                            });
                            this.hasApplyNo = this.fieldNameList.indexOf('applyNo') !== -1;
                        }
                    })
            },
            searchHandler() {
                this.getNoticeApplyStuPageListFunc();
            },
            getNoticeApplyStuPageListFunc() {
                getNoticeApplyStuPageList({
                    homeAddress: '',
                    noticeId: this.currentNotice,
                    searchVal: this.searchVal,
                    pageNo: this.pagination.pageNo,
                    state: 8,
                    pageSize: this.pagination.pageSize
                })
                    .then(res => res.data)
                    .then(data => {
                        this.dataList = data.data.dataList;
                        this.pagination.total = data.data.pagination.total;
                    })
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin.scss";

    .table-container {
        width: 92%;
        min-width: 1200px;
        padding: 5px 0;
    }
    .second-header-wrap {
        left: 0;
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 0;
        background-color: #fff;
        z-index: 1000;
    }
    .main-wrap {
        width: 100%;
        margin-top: 229px;
    }

    .main-container {
        width: 1320px;
        padding: 30px 10px;
        margin: 0 auto;
        min-height: 560px;
    }

    .custom—scrollbar {
        overflow-x: hidden;
        overflow-y: auto;
    }

    .custom—scrollbar::-webkit-scrollbar {
        width: 6px;
        background-color: rgba(255, 255, 255, 0.1);
    }

    .custom—scrollbar::-webkit-scrollbar-thumb {
        background-color: #999;
    }

    .custom—scrollbar::-webkit-scrollbar-track {
        background-color: rgba(255, 255, 255, 0.1);
    }
</style>
<style>
    #schoolSignupNoticeList a {
        color: #409EFF;
        text-decoration: none;
    }
    .addExamBox .el-radio__label{
        display: inline-block;
        min-width:42px;
    }
</style>




// WEBPACK FOOTER //
// src/views/primary/review/ReviewReserve.vue